// Arquivo gerado automaticamente no deploy
export const APP_VERSION = '9.2.7';
